import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import PageLoader from '../loaders/pageLoader';
import { supportLoader } from '../loaders/support';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../queryClient';

const AmexSupportComponent = lazy(() => import('../../components/pages/support/amex'));

const supportPath = '/support' as const;

export const supportRoutes = {
	path: supportPath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<ProtectedRoute allowedRoles={['*']}>
					<Suspense fallback={<PageLoader />}>{<AmexSupportComponent />}</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				return supportLoader({ queryClient, ...ctx });
			},
		},
	],
};
